import { arrivalDateAtom as u, departureDateAtom as d } from "./index26.mjs";
import { generateDateMap as _ } from "./index71.mjs";
import { useAtomValue as c } from "jotai";
import { useState as w, useEffect as n } from "react";
const E = ({ setMaxDays: m, setMinDays: t }, f) => {
  const o = c(u), r = c(d), [s, p] = w(/* @__PURE__ */ new Map());
  return n(() => {
    o ? o && r && p(_(o, r)) : p(/* @__PURE__ */ new Map());
  }, [o, r]), n(() => {
    if (o && !r) {
      const e = f(o);
      e != null && e.max_stay && m(e == null ? void 0 : e.max_stay), e != null && e.min_stay && t(e == null ? void 0 : e.min_stay);
    } else
      m(0), t(0);
  }, [o, r, f, m, t]), { scopedMap: s, setScopedMap: p };
};
export {
  E as useDatePicker
};
